import { NavLink } from "react-router-dom";

/** 运营总览子页 tab（实时看板 / 深度分析 / 渠道客户用量）。 */
const TABS = [
  { to: "/ops/analytics", label: "📊 实时看板", end: true },
  { to: "/ops/analytics/deep", label: "📈 深度分析 + 预测", end: false },
  { to: "/ops/analytics/channel-usage", label: "👥 渠道客户用量", end: false },
];

export function OperationsTabs() {
  return (
    <div className="flex gap-1 border-b border-slate-200">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end}
          className={({ isActive }) =>
            `border-b-2 px-4 py-2 text-[13px] font-medium ${
              isActive ? "border-blue-600 text-blue-700" : "border-transparent text-slate-500 hover:text-slate-700"
            }`
          }
        >
          {t.label}
        </NavLink>
      ))}
    </div>
  );
}
